import { buildInterviewFormValues, buildInterviewPayload } from 'features/sendouts/common/utils';
import { prepareFormToSubmit } from 'UI/utils/forms';

import { OTHER_INTERVIEWER_FORM_FIELDS_MAP } from '../../shared';

const buildEmailPickerValues = (emails = []) =>
  emails.map(email => (typeof email === 'string' ? { work_email: email } : email));

export const buildSendoutInterviewPayload = (formData = {}) => {
  const otherInterviewerPayload = prepareFormToSubmit(formData, OTHER_INTERVIEWER_FORM_FIELDS_MAP);
  const { cc_emails: ccs, email, full_name } = otherInterviewerPayload;

  return {
    // TODO: the API still requires interview_type_id at the root and rejects this payload with a
    // 400 until the backend reads the value from the nested `interview` object. Keep it nested.
    interview: {
      ...buildInterviewPayload(formData),
      ccs,
      otherInterviewer: {
        email,
        full_name
      }
    }
  };
};

export const buildSendoutInterviewDefaultValues = (interview = {}) => ({
  ...buildInterviewFormValues(interview),
  otherInterviewerFullName: interview.otherInterviewerFullName ?? '',
  otherInterviewerEmail: interview.otherInterviewerEmail ?? '',
  otherInterviewerCarbonCopy: buildEmailPickerValues(interview.otherInterviewerCcEmails ?? [])
});
